import { Divider, Label } from "@fluentui/react-components";
import styled, { css } from "styled-components";

export const NoteWrapper = styled.div`
  gap: 4px;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const NoteLabelWrapper = styled.div`
    gap: 8px;
    display: flex;
    flex-direction: flex-start;
`;

export const NoteLabelCreationDate = styled(Label)`
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
`;

export const NoteLabel = styled(Label)`
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
`;

export const Frame = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  border: 1px solid ${(props) => props.theme.serviceDeskNoteBorder};
  background-color: ${(props) => props.theme.serviceDeskNoteBackground};
  border-radius: 4px;
  padding: 4px 8px 8px 8px;
  gap: 8px;
`;

export const NoteTextArea = styled.div`
    width: 100%;  
    font-size: 14px;
    line-height: 20px;
    white-space: pre-wrap;
`;

export const StatusChangedDividerWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  height: fit-content;
  justify-content: center;
  align-items: center;
`;

export const StatusChangedDivider = styled(Divider)`
  color: ${(props) => props.theme.serviceDeskNotesDivider};
  ::before{
    border-color: ${(props) => props.theme.serviceDeskNotesDivider};
  }
  ::after{
    border-color: ${(props) => props.theme.serviceDeskNotesDivider};
  }
`;

export const StatusChangedContentWrapper = styled.div`
    @media (max-width: 710px) {
      max-width: 65vw;
  }
`;

export const StatusChangedText = css`
  font-size: 12px;
  line-height: 16px;
`;

export const StatusChangedStrong = styled.span`
  ${StatusChangedText};
  font-weight: 600;
`;